import { render, staticRenderFns } from "./MyCustomSelect.vue?vue&type=template&id=37896b02&scoped=true"
import script from "./MyCustomSelect.vue?vue&type=script&lang=js"
export * from "./MyCustomSelect.vue?vue&type=script&lang=js"
import style0 from "./MyCustomSelect.vue?vue&type=style&index=0&id=37896b02&prod&lang=scss&scoped=true"
import style1 from "./MyCustomSelect.vue?vue&type=style&index=1&id=37896b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37896b02",
  null
  
)

export default component.exports